import { render, staticRenderFns } from "./HeatingRenovation.vue?vue&type=template&id=2953b613&scoped=true&"
import script from "./HeatingRenovation.vue?vue&type=script&lang=js&"
export * from "./HeatingRenovation.vue?vue&type=script&lang=js&"
import style0 from "./HeatingRenovation.vue?vue&type=style&index=0&id=2953b613&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953b613",
  null
  
)

export default component.exports